__webpack_require__.p = "/bh/invest/funds/";